module.exports = __webpack_public_path__ + "static/media/collections.4aab963d.svg";